__webpack_require__.p = "https://gopay-web-page.gopayapi.com/";